import ReactDOM from "react-dom";
import React from "react";
import $ from "jquery";

import "bootstrap";
import "./main.scss";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fad } from "@fortawesome/pro-duotone-svg-icons";

library.add(fad);

if (window.global === undefined) {
    window.global = window;
}
